import { useMemo } from 'react';
import clsx from 'clsx';

import { useSchemas } from '@atom/hooks/useSchemas';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { ReportMaterial } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  reportMaterial: ReportMaterial;
  isCompletedOrAbove: boolean;
}

const ReportStartEndRow = ({ reportMaterial, isCompletedOrAbove }: Props) => {
  const { schemas = [] } = useSchemas();

  const schema = useMemo(() => {
    return schemas.find(({ id }) => id === reportMaterial.schemaId);
  }, [schemas, reportMaterial.schemaId]);

  const entries = isNilOrEmpty(reportMaterial?.entries)
    ? [
        {
          id: `empty${reportMaterial?.assetId}`,
          startReading: 0,
          endReading: 0,
          amount: 0,
        },
      ]
    : reportMaterial?.entries;

  const name = reportMaterial?.unit
    ? `${reportMaterial?.name} (${reportMaterial?.unit.toUpperCase()})`
    : reportMaterial?.name;

  return (
    <div className={classes.startEndRow}>
      <div className={classes.startEndType}>{schema?.name || ''}</div>
      <div className={classes.startEndName}>{name}</div>
      <div className={classes.startEndSubContainer}>
        {entries.map(entry => (
          <div key={entry?.id} className={classes.startEndRowSub}>
            <div className={classes.startEndValue}>
              {entry?.startReading || ''}
            </div>
            <div className={classes.startEndValue}>
              {entry?.endReading || ''}
            </div>
            <div className={clsx(classes.startEndValue, classes.used)}>
              {entry?.amount || ''}
            </div>
            {isCompletedOrAbove && (
              <div className={classes.startEndValue}>
                {reportMaterial?.rate && entry?.amount
                  ? numberToLocaleString(reportMaterial?.rate * entry?.amount)
                  : ''}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportStartEndRow;
